/**
 * Checkbox — atom (ADR-0007). WCAG 2.5.5 Target Size AA (24×24).
 * Uses native input with accent-color (no Radix dependency for now — keep bundle small).
 */
import { forwardRef, type InputHTMLAttributes } from 'react'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  size?: 'sm' | 'md' | 'lg'
}

const sizeMap = {
  sm: 'w-5 h-5',
  md: 'w-6 h-6',
  lg: 'w-7 h-7',
} as const

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { size = 'md', className = '', ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      type="checkbox"
      className={`accent-accent-brand-primary cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-border-focus/40 rounded disabled:cursor-not-allowed ${sizeMap[size]} ${className}`}
      {...rest}
    />
  )
})
